export class RestoreAccountRegions {
    'regions';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountRegions.attributeTypeMap;
    }
    constructor() {
    }
}
